/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Coach_BodyInputs */

const en_portal_hero_coach_body = /** @type {(inputs: Portal_Hero_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions, a plan from your coach and payments in one app.`)
};

const pl_portal_hero_coach_body = /** @type {(inputs: Portal_Hero_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminy, plan od trenera i płatności w jednej aplikacji.`)
};

/**
* | output |
* | --- |
* | "Sessions, a plan from your coach and payments in one app." |
*
* @param {Portal_Hero_Coach_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_coach_body = /** @type {((inputs?: Portal_Hero_Coach_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Coach_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_coach_body(inputs)
	return en_portal_hero_coach_body(inputs)
});